// extracted by mini-css-extract-plugin
export default {"bookList":"BookList_bookList__u-Aat","wrapper":"BookList_wrapper__8yoSJ"};